import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["date", "onChange", "onMonthChange", "minDate", "maxDate", "disablePast", "disableFuture"];
import React from 'react';
import PropTypes from 'prop-types';
import DateUtils from '../../utils/date';
import Month from './Month';
import { MonthViewContainer } from './styles';
var utils = new DateUtils();
var YearView = function YearView(_ref) {
  var date = _ref.date,
    onChange = _ref.onChange,
    onMonthChange = _ref.onMonthChange,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    disablePast = _ref.disablePast,
    disableFuture = _ref.disableFuture,
    other = _objectWithoutProperties(_ref, _excluded);
  var currentMonth = utils.getMonth(date);
  var shouldDisableMonth = function shouldDisableMonth(month) {
    var now = utils.date();
    var utilMinDate = utils.date(minDate);
    var utilMaxDate = utils.date(maxDate);
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
    var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
    var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
    return isBeforeFirstEnabled || isAfterLastEnabled;
  };
  var onMonthSelect = React.useCallback(function (month) {
    var newDate = utils.setMonth(date, month);
    if (onMonthChange) onMonthChange(newDate);
    if (onChange) onChange(newDate, true);
  }, [date, onChange, onMonthChange, utils]);
  return /*#__PURE__*/React.createElement(MonthViewContainer, other, utils.getMonthArray(date).map(function (month) {
    var monthNumber = utils.getMonth(month);
    var monthText = utils.format(month, 'MMM');
    return /*#__PURE__*/React.createElement(Month, {
      key: monthText,
      value: monthNumber,
      selected: monthNumber === currentMonth,
      onSelect: onMonthSelect,
      disabled: shouldDisableMonth(month)
    }, monthText);
  }));
};
YearView.protoTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
  onChange: PropTypes.func,
  onMonthChange: PropTypes.func,
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date).isRequired
};
YearView.defaultProps = {
  disablePast: false,
  disableFuture: false
};
export default YearView;